import { XMarkIcon } from '@heroicons/react/20/solid'
import { Transition } from '@headlessui/react'
import { Fragment, useState, useEffect } from 'react'

const BANNER_KEY = 'banner-closed'
const COOLDOWN_SECONDS = 10
const AUTO_DISMISS_SECONDS = 60
const END_DATE = new Date('2025-05-31')

const getInitialState = () => {
  if (typeof window === 'undefined') return true
  
  const storedData = localStorage.getItem(BANNER_KEY)
  if (!storedData) return true

  const { closedAt } = JSON.parse(storedData)
  const closedDate = new Date(closedAt)
  const now = new Date()
  
  if (now > END_DATE) return false

  const secondsSinceClosed = Math.floor((now.getTime() - closedDate.getTime()) / 1000)
  return secondsSinceClosed >= COOLDOWN_SECONDS
}

const Banner = () => {
  const [isOpen, setIsOpen] = useState(getInitialState)

  useEffect(() => {
    const storedData = localStorage.getItem(BANNER_KEY)
    if (storedData) {
      const { closedAt } = JSON.parse(storedData)
      const closedDate = new Date(closedAt)
      const now = new Date()
      
      if (now > END_DATE) {
        setIsOpen(false)
        return
      }

      const secondsSinceClosed = Math.floor((now.getTime() - closedDate.getTime()) / 1000)
      if (secondsSinceClosed < COOLDOWN_SECONDS) {
        setIsOpen(false)
      }
    }
  }, [])

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        handleClose()
      }, AUTO_DISMISS_SECONDS * 1000)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const handleClose = () => {
    setIsOpen(false)
    localStorage.setItem(BANNER_KEY, JSON.stringify({
      closedAt: new Date().toISOString()
    }))
  }

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      leave="transition ease-in duration-300"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-1"
    >
      <div className="flex mt-[57px] lg:mt-0 items-center gap-x-6 bg-blue-400 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
        <p className="text-xs lg:text-sm/6 text-white text-center w-full font-bold sm:font-normal">
          <strong className="font-bold sm:font-semibold">We're Growing!</strong>
          {` `}
          We've moved to a new location — come visit us at 55 Renfrew Dr, Markham, ON L3R 8H3.
        </p>
        <div className="flex flex-1 justify-end">
          <button
            type="button"
            className="-m-3 p-3 focus-visible:outline-offset-[-4px] sm:bg-transparent bg-blue-500 rounded-full hover:bg-blue-600 transition-colors"
            onClick={handleClose}
          >
            <span className="sr-only">Dismiss</span>
            <XMarkIcon aria-hidden="true" className="lg:size-5 md:size-4 size-3 text-white" />
          </button>
        </div>
      </div>
    </Transition>
  )
}

export default Banner
